/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Manual_WindInputs */

const en_val_manual_wind = /** @type {(inputs: Val_Manual_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual Wind`)
};

const es_val_manual_wind = /** @type {(inputs: Val_Manual_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuerda manual`)
};

const fr_val_manual_wind = /** @type {(inputs: Val_Manual_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remontage manuel`)
};

const de_val_manual_wind = /** @type {(inputs: Val_Manual_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handaufzug`)
};

const ja_val_manual_wind = /** @type {(inputs: Val_Manual_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手巻き`)
};

const zh_val_manual_wind = /** @type {(inputs: Val_Manual_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手动上链`)
};

const ar_val_manual_wind = /** @type {(inputs: Val_Manual_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعبئة يدوية`)
};

const id_val_manual_wind = /** @type {(inputs: Val_Manual_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putar Manual`)
};

const it_val_manual_wind = /** @type {(inputs: Val_Manual_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica Manuale`)
};

const ru_val_manual_wind = /** @type {(inputs: Val_Manual_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ручной завод`)
};

const pt_val_manual_wind = /** @type {(inputs: Val_Manual_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corda Manual`)
};

const ko_val_manual_wind = /** @type {(inputs: Val_Manual_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수동 감기(매뉴얼)`)
};

/**
* | output |
* | --- |
* | "Manual Wind" |
*
* @param {Val_Manual_WindInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_manual_wind = /** @type {((inputs?: Val_Manual_WindInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Manual_WindInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_manual_wind(inputs)
	if (locale === "es") return es_val_manual_wind(inputs)
	if (locale === "fr") return fr_val_manual_wind(inputs)
	if (locale === "de") return de_val_manual_wind(inputs)
	if (locale === "ja") return ja_val_manual_wind(inputs)
	if (locale === "zh") return zh_val_manual_wind(inputs)
	if (locale === "ar") return ar_val_manual_wind(inputs)
	if (locale === "id") return id_val_manual_wind(inputs)
	if (locale === "it") return it_val_manual_wind(inputs)
	if (locale === "ru") return ru_val_manual_wind(inputs)
	if (locale === "pt") return pt_val_manual_wind(inputs)
	return ko_val_manual_wind(inputs)
});